<template>
  <treeselect
    v-model="local_value"
    :placeholder="placeholder"
    :multiple="multiple"
    :flat="multiple"
    :options="options"
    :class="[stateClass]"
    @select="selectNode"
    @deselect="deselectNode"
  />
</template>

<script>
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";
import { map, uniq, isArray } from "lodash";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: [],
    placeholder: {
      type: String,
      default: "Selecione  ...",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disable_node: {
      type: Number,
      default: 0,
    },
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    arvore: [],
  }),
  computed: {
    local_value: {
      set(value) {
        let emit_value;
        if (this.multiple) {
          emit_value = [];
          value.forEach((id) => {
            emit_value.push({ id: id });
          });
        } else {
          emit_value = value;
        }
        this.$emit("input", emit_value);
      },
      get() {
        let response;
        if (this.multiple) {
          response = [];
          if (Array.isArray(this.value)) {
            response = _.map(this.value, "id");
          }
        } else {
          response = this.value;
        }
        return response;
      },
    },
    options() {
      let recursive_children = (arvore) => {
        let options = map(arvore, (node) => {
          let option = {
            id: node.id,
            label: node.nome,
            isDisabled: node.id == this.disable_node,
          };

          if (node.children) {
            option.children = recursive_children(node.children);
          }

          return option;
        });
        return options;
      };

      let options = recursive_children(this.arvore);
      return options;
    },
  },
  methods: {
    ...mapActions("areas", ["ActionArvore"]),
    async selectNode(node, instanceId) {
      if (this.multiple) {
        let recursive_children = (arvore, id) => {
          let parent_id = null;
          arvore.forEach((node) => {
            if (parent_id == null) {
              if (node.id == id) {
                parent_id = node.area_id;
              } else if (node.children) {
                parent_id = recursive_children(node.children, id);
              }
            }
          });
          return parent_id;
        };
        var selecteds = this.local_value;
        selecteds.push(node.id);
        let parent_id = await recursive_children(this.arvore, node.id);
        while (parent_id) {
          selecteds.unshift(parent_id);
          parent_id = recursive_children(this.arvore, parent_id);
        }

        selecteds = uniq(selecteds);
        this.local_value = selecteds;
      }
    },
    async deselectNode(node, instanceId) {
      let recursive_children = (node) => {
        let node_ids = [];
        if (node.children) {
          node.children.forEach((child) => {
            node_ids.push(child.id);

            if (child.children) {
              node_ids.push(...recursive_children(child));
            }
          });
        }

        return node_ids;
      };

      if (this.multiple) {
        let node_ids = await recursive_children(node);
        this.local_value = _.difference(this.local_value, node_ids);
      }
    },
  },
  async created() {
    this.arvore = await this.ActionArvore();
    //this.localValue = this.value;
  },
};
</script>
